/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

// Modern browsers and Node 22+ have native support for async/await
// No need for regenerator-runtime anymore
import React, { useState, useEffect } from 'react'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'

import { PostConfiguration } from '@professocial/professocialTypes/types'

// Post
import { postingRootReducer } from '@professocial/professocialPosting/src/store/postingRoot.reducer'
import { postingRootSagas } from '@professocial/professocialPosting/src/store/postingRoot.sagas'
import ProfessocialPost from '@professocial/professocialPosting/src/screens/ProfessocialPost'

interface IImportProfessocialNetworkContentProps {
  postConfiguration?: PostConfiguration
}

// NetworkContent
const sagaMiddleware = createSagaMiddleware()
// Create a compose enhancer that uses Redux DevTools if available
const composeEnhancers = typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ 
  ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) 
  : compose

const storePost = createStore(
  postingRootReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
)
sagaMiddleware.run(postingRootSagas)

const ImportProfessocialPost: React.FC<IImportProfessocialNetworkContentProps> = (props) => {
  const [postConfiguration, setPostConfiguration] = useState<PostConfiguration>()

  useEffect(() => {
    setPostConfiguration(props.postConfiguration)
  }, [props.postConfiguration],
  )

  return (
    <Provider store={storePost}>
      <ProfessocialPost
        postConfiguration={postConfiguration}
      />
    </Provider>
  )
}
export default ImportProfessocialPost
